import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';

import { GdprCandidateEffects } from './gdpr-candidate.effects';

@NgModule({
  imports: [EffectsModule.forFeature([GdprCandidateEffects])],
})
export class GdprCandidateDataModule {}
